// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"76468020","453":"51556263","455":"c3dc1dc1"}[chunkId] + ".chunk.js";
};